module.exports = __webpack_public_path__ + "static/media/logoLogin.8c5517e2.svg";